import { useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import CalcHero from "./components/CalcHero";
import CalcTips from "./components/CalcTips";
import RoomAccordion from "./components/RoomAccordion";
import SummaryPanel from "./components/SummaryPanel";
import QuoteModal from "../home/components/QuoteModal";
import { homeRooms } from "../../mocks/calculatorData";
import type { Selections } from "../../mocks/calculatorData";
import { useWCLoadSizes } from "../../hooks/useWCProducts";

export default function WasteCalculatorPage() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [selections, setSelections] = useState<Selections>({});

  // Live load sizes from WooCommerce — falls back to mock data if API unavailable
  const { loadSizes } = useWCLoadSizes();

  const handleUpdate = (itemId: string, qty: number) => {
    setSelections((prev) => {
      if (qty <= 0) {
        const next = { ...prev };
        delete next[itemId];
        return next;
      }
      return { ...prev, [itemId]: qty };
    });
  };

  const handleClear = () => setSelections({});

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onBookNow={() => setQuoteOpen(true)} />
      <main className="flex-1">
        <CalcHero />
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 py-12">
          <div className="flex flex-col lg:flex-row gap-8 items-start">

            {/* Room accordions */}
            <div className="flex-1 min-w-0">
              <CalcTips />
              <div className="mt-8">
                <RoomAccordion
                  rooms={homeRooms}
                  selections={selections}
                  onUpdate={handleUpdate}
                />
              </div>
            </div>

            {/* Summary panel — uses live WC load sizes */}
            <div className="w-full lg:w-[400px] flex-shrink-0 sticky top-24">
              <SummaryPanel
                rooms={homeRooms}
                selections={selections}
                onClear={handleClear}
                loadSizes={loadSizes}
              />
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {quoteOpen && <QuoteModal onClose={() => setQuoteOpen(false)} />}
    </div>
  );
}
